import React from 'react'
import { TableCell, makeStyles } from '@material-ui/core'

type Props = {
  children?: string
  title?: string
  highlight?: boolean
}

const useStyles = makeStyles(() => ({
  highlightFont: {
    fontWeight: 'bold',
  },
}))

export function TableTitleCell({
  children,
  title = children,
  highlight = false,
}: Props): React.ReactElement {
  const classes = useStyles()

  return (
    <TableCell className={highlight ? classes.highlightFont : undefined}>
      {title}
    </TableCell>
  )
}
